import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import { MainModalController, ModalHeading, RadioButton } from '@uikit';

import { voteBoxImg } from '@shared/assets/images/scope/projectValidation';

import { VOTE_CHOICE, VoteChoiceValue } from './useVoteStrategy';

export interface VotingModalProps {
  validation: any;
  appId: string;
  appName: string;
  onSuccess: () => void;
  modalController: MainModalController;
}

interface VoteChoiceStepProps {
  choice?: VoteChoiceValue;
  onChoiceChange: (choice: VoteChoiceValue) => void;
  onNext: () => void;
}

const VoteChoiceStep = ({ choice, onChoiceChange, onNext }: VoteChoiceStepProps) => {
  return (
    <>
      <ImageProxy
        className="h-[138px] w-auto mx-auto"
        src={voteBoxImg}
        alt=""
        width={510}
        height={416}
      />

      <ModalHeading>Vote Responsibly</ModalHeading>

      <p className="bg-primary-100 rounded-2xl p-6 font-medium text-secondary text-center">
        Your decision contributes to the quality and integrity of the Magic Store listings.
      </p>

      <div className="flex gap-6 items-center justify-center flex-grow h-[80px]">
        <label
          className={classNames(
            'rounded flex items-center justify-center border border-neutral-200 flex-grow h-full transition duration-300 cursor-pointer',
            {
              'bg-green-50 border-green-500': VOTE_CHOICE.YES === choice,
            },
          )}
          data-qa="vote-yes-choice"
        >
          <RadioButton
            labelClassName="!flex-col-reverse"
            name="vote"
            label="Yes"
            checked={VOTE_CHOICE.YES === choice}
            value={VOTE_CHOICE.YES}
            onChange={() => onChoiceChange(VOTE_CHOICE.YES)}
          />
        </label>

        <label
          className={classNames(
            'rounded flex items-center justify-center border border-neutral-200 flex-grow h-full transition duration-300 cursor-pointer',
            {
              'bg-red-100 border-red-600': VOTE_CHOICE.NO === choice,
            },
          )}
          data-qa="vote-no-choice"
        >
          <RadioButton
            labelClassName="!flex-col-reverse"
            name="vote"
            label="No"
            checked={VOTE_CHOICE.NO === choice}
            value={VOTE_CHOICE.NO}
            onChange={() => onChoiceChange(VOTE_CHOICE.NO)}
          />
        </label>
      </div>

      <button
        className={classNames('button button-solid-primary button-lg mt-4 w-full')}
        disabled={!choice}
        onClick={onNext}
        data-qa="vote-next-button"
      >
        Next
      </button>
    </>
  );
};

export default VoteChoiceStep;
